import React from "react";

import { CatalogStore } from "stores";

import Chip from "../../ChipIndicator";

interface IModellIndicator {
  filter: number[];
  dispatch?: any;
}

const ModellIndicator: React.FC<IModellIndicator> = ({
  filter,
  dispatch,
}): JSX.Element | null => {
  const {
    state: {
      entities: { modell },
    },
  } = React.useContext(CatalogStore);

  if (!(filter.length && modell)) return null;

  const handleDelete = (modell: any) => {
    dispatch({
      type: "REMOVE_ID_FROM_FILTER",
      payload: { filter: "modell", id: modell },
    });
  };
  return (
    <>
      {filter.map((id: number) => {
        if (!modell[id]) return null;
        return (
          <Chip
            id={id}
            key={id}
            label={modell[id].name}
            onDelete={() => handleDelete(id)}
          />
        );
      })}
    </>
  );
};

export default ModellIndicator;
